import actions from './actions'
import mutations from './mutations'
import {DESTINATIONS} from '@/appLogic/targets/Constants'

/**
 * How to add modules after a store has been created...
 */

const DEFAULT_STATE = {
  interface: undefined,
  enableUpdateInsights: false,
  enableUpdateTargetHeaderData: true,
  loadingInsights: false,
  useMockData: false,
  query: null,
  ueModalShower: 0,
  liveDigitalPromptShower: 0,
  queryErroredOut: false,
  traits: null,
  BYODTraits: null,
  showModelingModal: 0  // shows the modeling Modal
}

const state = function () {
  return {
    ...DEFAULT_STATE
  }
}

const getters = {
  xandrUEModalShower (state) {
    return state.ueModalShower
  },
  xandrLiveDigitalPromptShower (state) {
    return state.liveDigitalPromptShower
  },
  xandrUpdateInsightsEnabled (state) {
    return state.enableUpdateInsights
  },
  xandrLoadingInsights (state) {
    return state.loadingInsights
  },
  xandrUseMockData (state) {
    return state.useMockData
  },
  xandrQuery (state) {
    return state.query
  },
  xandrInterface (state) {
    return state.interface
  },
  xandrIsLiveAndHasUnsubmittedChanges (state, getters) {
    let target = getters.newWorkbenchTarget
    return (
      (getters.workbenchTargetIsLive &&
        (
          getters.saveXandrSegmentEnabled ||
          ((target || {}).activation_date !== (target || {}).last_update)
        )
      )
    )
  },
  xandrIsDigitalSocialDestination (state, getters) {
    let destinations = (getters.newWorkbenchTarget || {}).destinations || []
    return destinations.some(destination => [DESTINATIONS.KRUX, DESTINATIONS.LIVERAMP].includes(destination))
  },
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module
export {DEFAULT_STATE as XANDR_DEFAULT_STATE}



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/Xandr/store/index.js